export default {
      id: "right-arrow-neo-usage",
      viewBox: "0 0 46 87",
      url: __webpack_public_path__ + "img/icons.df848786.svg#right-arrow-neo",
      toString: function () {
        return this.url;
      }
    }